import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class IncomeService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/incomes/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/incomes')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createIncome(lookup: Lookup) {
        return this.httpClient.post('api/incomes/create', lookup.data).toPromise();
    }

    editIncome(lookup: Lookup) {
        return this.httpClient.post('api/incomes/edit', lookup.data).toPromise();
    }

    deleteIncome(ids: Array<Number>) {
        return this.httpClient.post('api/incomes/delete', ids).toPromise();
    }

}